// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draft-creative__right-rail{position:absolute;top:0;right:0px;transform:translateX(1000px);height:calc(100vh - 56px);width:40vw;max-width:640px;box-shadow:-4px 0 4px #00000020;background-color:#fff;display:none;padding-top:2rem}.draft-creative__right-rail.show{display:block;transform:translateX(0)}.draft-creative__right-rail .top-performers{height:100%;overflow:auto}.draft-creative__right-rail .top-performers .recommendation-card__preview{cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
